import {
	HubDataSource,
	HubItemCategoryModel,
	HubItemHubSidebarNodeModel,
	RootHubSidebarNodeModel
} from "client/Api/Hub/hub";
import { HubItemKind } from "client/Api/Hub/hubItemCategories";
import { useMemo } from "react";
import { isNotNil } from "client/Misc/utils";
import { HubItemCategoryNodeKind } from "client/Api/Hub/common";
import { never } from "client_legacy/ndaw/errors";

export function useCategories(
	hierarchy: readonly RootHubSidebarNodeModel[],
	hubItemKind?: HubItemKind
): OptionalModel<readonly HubItemCategoryModel[]> {
	return useMemo(
		(): OptionalModel<readonly HubItemCategoryModel[]> => {
			if (hierarchy.length === 0) {
				return { isSet: false };
			}

			let categories: readonly HubItemCategoryModel[] = getCategories(hierarchy);
			if (isNotNil(hubItemKind)) {
				categories = categories
					.filter((x) => x.hubItemKind === hubItemKind);
			}

			return {
				isSet: true,
				value: categories
			};
		} ,
		[hierarchy, hubItemKind]
	);
}

function getCategories(
	rootItems: readonly RootHubSidebarNodeModel[]
): readonly HubItemCategoryModel[] {
	const result: HubItemCategoryModel[] = [];

	for (const rootItem of rootItems) {
		switch (rootItem.source) {
			case HubDataSource.Announcement:
			case HubDataSource.KnowledgeItem:
			case HubDataSource.Event:
				for (const child of rootItem.children) {
					const categories: readonly HubItemCategoryModel[] = getCategoriesRecursive(child);
					result.push(...categories);
				}
				break;
			case HubDataSource.Community:
				// Nothing
				break;
			default:
				never(rootItem);
		}
	}

	return result;
}

function getCategoriesRecursive(
	item: HubItemHubSidebarNodeModel
): readonly HubItemCategoryModel[] {
	const result: HubItemCategoryModel[] = [];

	if (item.kind === HubItemCategoryNodeKind.Category) {
		result.push(item.category);
	} else {
		for (const child of item.children) {
			const categories: readonly HubItemCategoryModel[] = getCategoriesRecursive(child);
			result.push(...categories);
		}
	}

	return result;
}
